<template>
    <article>
        <h1>Infinite Hyrule</h1>
        <h3>2020 - Present</h3>

        <section>
            <div class="links">
                <p>
                    <a href="https://bitbucket.org/Garmichael/infinite-hyrule/downloads/" target="_blank">
                        Download Infinite Hyrule
                    </a>
                </p>
            </div>

            <div class="two-columns">
                <div>
                    <img src="../assets/page-infinite-hyrule/screenshot.png" alt="Infinite Hyrule Map Screenshot">
                </div>

                <div>
                    <p>
                        Procedurally generate new Overworld maps for the Legend of Zelda (Nes), and play them in your
                        favorite emulator.
                    </p>

                    <p>
                        Apply this Randomizer to your Zelda Rom like you would any other Randomizer. This is compatible
                        with the Z1R Randomizer.
                    </p>
                </div>
            </div>

            <div class="one-column">
                <img src="../assets/page-infinite-hyrule/sample-screens.png" alt="Infinite Hyrule Sample Screens">
            </div>
        </section>

        <h2>About the Development of Infinite Hyrule</h2>
        <h3> C#, WPF, .NET, AdonisUI, ASM, Hex Editing, Procedural Generation</h3>
        <section>
            <div class="links">
                <p>
                    <a href="https://bitbucket.org/Garmichael/infinite-hyrule/src/master/" target="_blank">
                        Infinite Hyrule Source Code on BitBucket
                    </a>
                </p>
            </div>

            <div class="one-column">
                <p>
                    I built this project mainly out of passion and an interest in expanding my skillset into procedural
                    generation and working within the strict limitations of an NES cart. There were many challenges I
                    had to overcome with this project, such as deconstructing how data was read and stored in the rom,
                    learning some basic ASM, and of course the core logic of generating a pathing map that ensures every
                    screen can be accessed and making each screen feel believable and not just a mess of tiles.
                </p>
                <p>
                    This project required a lot of studying and decoding proprietary data formats that were encoded into
                    the Rom. I also had to find creative solutions to building screens and adding new tiles. I also had
                    never done any procedural generation so I had to study up on techniques for that. This was also the
                    first WPF application I had built so I had to figure that out too, though that part was pretty easy.
                </p>
                <p>
                    Before I could start code, I had to investigate the format that the Rom saves screen data in. This
                    required a couple days of browsing forum posts and documentation that other people wrote. The format
                    is difficult to parse, as it stores screen tiles in pre-made, compressed columns. I had to
                    understand the format, decompress it, and then compress it again.
                </p>
                <p>
                    The screens are defined by their Biome, and each Biome has its own rules for generation. The goal
                    was to make each screen feel as believable as possible, maintaining the design conventions of the
                    original game. However, several Biomes were enhanced with extra detail while staying close to the
                    original aesthetic - adding extra grass or sandy tiles or extra rocks here and there.
                </p>
                <p>
                    At some point, I realized I couldn't build the screens easily unless the column format was
                    circumvented somehow. I posted about it on Romhacking.net and another user volunteered to write ome
                    advanced ASM to expand the Rom and make every screen have its own specific layout. This opened the
                    procedural generation to unlimited potential.
                </p>
                <p>
                    Later, I decided I wanted to add new tiles to the tileset for things like Palm Trees and Houses, to
                    add some variety and flavor to the randomizer. This required another deep dive into the rom's data
                    formats. Once I had it figured out, I drew up the new tiles and injected them into the Rom. There
                    were more issues related to the format that I had to work around. For example, there is an index for
                    tiles that act as Stairs into caves, where every tile past that index would act like stairs unless
                    they were past the index for another property like Solid or Water. Without getting too technical, I
                    had to be creative about rearranging the tiles so that every tile functioned properly, and rewrote
                    ASM that replaced some tiles with stairs (in the cases of Armos Statues, Dried Water, and Burned
                    Bushes).
                </p>
                <p>
                    Finally, since Infinite Hyrule was only meant to generate a new overworld, and not randomize
                    dungeons or items, I wanted to make sure it was compatible with Fred Coughlin's Z1R randomizer that
                    did randomize those elements. This required a lot of testing and examining what changes his
                    randomizer did to the Rom to make sure none of my custom ASM code was conflicting with changes from
                    Z1R.
                </p>
                <p>
                    In the end, this project was a lot of fun, achieved the goal I had set out, and has received high
                    praise from users who have played seeds from it, claiming that the results look hand-crafted. A
                    success all around.
                </p>
            </div>
        </section>


    </article>
</template>

<script>
    export default {
        name: "InfiniteHyrule"
    }
</script>